import styled from '@emotion/styled';
import PropTypes from 'prop-types';
// import { useSelector } from 'react-redux';
import H4 from '@base/H4/H4';
import H6 from '@base/H6/H6';
import Button from '@base/Button/Button';
import { Spacings, Fonts } from '@styles/index';
import BottomSheet from '@comp/BottomSheet/BottomSheet';
import Coin from '@icon/Coin';
import useNotEnoughCredits from './useNotEnoughCredits';

const StyledH4 = styled(H4)`
  text-align: center;
  margin-bottom: ${Spacings.SPACING_2B};
`;

const TotalContainer = styled.div`
  display: grid;
  align-items: center;
  justify-content: center;
  grid-template: 1fr / repeat(3, max-content);
  grid-column-gap: ${Spacings.SPACING_1B};
  margin: ${Spacings.SPACING_2B} 0px ${Spacings.SPACING_8B};
`;

const Text = styled(H6)`
  font-weight: ${Fonts.REGULAR};
  text-align: center;
`;

const StyledBtn = styled(Button)`
  background-image: linear-gradient(
    180deg,
    var(--color-i-blue-4) 0%,
    var(--color-i-blue-3) 100%
  );
`;

// const ButtonsWrapper = styled.div`
//   display: grid;
//   grid-row-gap: ${Spacings.SPACING_4B};
// `;

const NotEnoughCredits = ({
  show,
  onClose,
  requiredCredits,
  goalUID,
  goalSlug,
  selectedCombatInfo
}) => {
  const { goToSubscriptionPage } = useNotEnoughCredits({
    goalSlug,
    goalUID,
    selectedCombatInfo
  });
  return (
    <BottomSheet open={show} onClose={onClose}>
      <StyledH4>Not enough credits</StyledH4>
      <TotalContainer>
        <Text>You need</Text>
        <Coin size="18px" viewBox="0 0 32 32" />
        <Text>{`${requiredCredits} to enroll in this contest`}</Text>
      </TotalContainer>
      {/* <Wrapper> */}
      <StyledBtn
        grid={5}
        color="green"
        variant="filled"
        label="Enroll with subscription"
        onClick={goToSubscriptionPage}
      />
      {/* <Button
          grid={5}
          color="green"
          variant="hollow"
          label="Get more credits"
          onClick={openArticle}
        /> */}
      {/* </Wrapper> */}
    </BottomSheet>
  );
};

NotEnoughCredits.propTypes = {
  show: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  requiredCredits: PropTypes.number.isRequired,
  goalUID: PropTypes.string.isRequired,
  goalSlug: PropTypes.string.isRequired,
  selectedCombatInfo: PropTypes.objectOf(PropTypes.any).isRequired
};

export default NotEnoughCredits;
